/**
 * Battle trust bars — rotate items on mobile (and desktop when enabled).
 */
(function () {
  function initTrust(root) {
    if (!root || root.dataset.battleTrustReady === 'true') return;
    root.dataset.battleTrustReady = 'true';

    const list = root.querySelector('[data-battle-trust-list]');
    if (!list) return;
    const items = Array.from(list.querySelectorAll(':scope > li'));
    if (items.length < 2) return;

    const interval = Number(root.dataset.interval || 4000);
    let index = 0;
    let timer = null;

    function isCarouselActive() {
      const desktopOn = root.classList.contains('battle-trust--desktop-carousel');
      const mobileOn = root.classList.contains('battle-trust--mobile-carousel');
      const wide = window.matchMedia('(min-width: 750px)').matches;
      return wide ? desktopOn : mobileOn;
    }

    function applyStatic() {
      items.forEach((item) => {
        item.classList.remove('is-active');
        item.hidden = false;
        item.setAttribute('aria-hidden', 'false');
      });
      list.classList.remove('battle-trust__list--carousel');
    }

    function applyCarouselFrame() {
      list.classList.add('battle-trust__list--carousel');
      items.forEach((item, i) => {
        const active = i === index;
        item.classList.toggle('is-active', active);
        item.hidden = !active;
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    function tick() {
      if (!isCarouselActive()) return;
      index = (index + 1) % items.length;
      applyCarouselFrame();
    }

    function start() {
      stop();
      if (!isCarouselActive()) {
        applyStatic();
        return;
      }
      applyCarouselFrame();
      timer = window.setInterval(tick, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    const mediaDesktop = window.matchMedia('(min-width: 750px)');
    const onChange = () => start();
    if (mediaDesktop.addEventListener) mediaDesktop.addEventListener('change', onChange);
    else mediaDesktop.addListener(onChange);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function boot() {
    document.querySelectorAll('[data-battle-trust], .battle-trust').forEach(initTrust);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.querySelector?.('[data-battle-trust], .battle-trust') || event.target;
    if (section?.matches?.('[data-battle-trust], .battle-trust') || section?.classList?.contains('battle-trust')) {
      section.dataset.battleTrustReady = 'false';
      initTrust(section);
    }
  });
})();
